import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CmsService, OccEndpointsService } from '@spartacus/core';
import { take } from 'rxjs';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';

export const SANOFI_ACCOUNT_OVERVIEW_BANNER_SLOT5 =
  'SanofiAccountOverviewBannerSlot5';

@Component({
  selector: 'app-sanofi-account-overview-banner-slot5',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sanofi-account-overview-banner-slot5.component.html',
  styleUrl: './sanofi-account-overview-banner-slot5.component.scss',
})
export class SanofiAccountOverviewBannerSlot5Component
  implements OnInit, OnDestroy
{
  cmsResponse: any;
  baseUrl: any;
  type: string;
  imageUrl: any;
  redirectionLink: any;
  modalSubscription: any;
  bannerList: any = [];
  tempPriority: number = 999;

  constructor(
    private readonly cmsData: CmsService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly _dataService: DataLayerService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit() {
    this.modalSubscription = this.cmsData
      .getContentSlot(SANOFI_ACCOUNT_OVERVIEW_BANNER_SLOT5)
      .subscribe((res) => {
        if (res && res?.components?.length > 0 && res?.components[0]?.uid) {
          this.cmsData
            .getComponentData(res.components[0].uid)
            .pipe(take(2))
            .subscribe((res1: any) => {
              this.bannerList = (res1?.sanofiBannerList ?? '')
                .split(' ')
                .filter((id: string) => id.length > 0);

              if (this.bannerList.length > 0) {
                this.bannerList.forEach((list: any) => {
                  this.cmsData.getComponentData(list).subscribe((res2: any) => {
                    const resPriority = +res2?.priority;
                    if (resPriority < this.tempPriority) {
                      this.applyBannerFromCms(res2);
                      this.tempPriority = resPriority;
                    }
                  });
                });
              } else {
                this.applyBannerFromCms(res1);
              }
            });
        }
      });
  }

  ngOnDestroy(): void {
    this.modalSubscription?.unsubscribe();
  }

  private applyBannerFromCms(banner: any): void {
    this.cmsResponse = banner;
    if (this.cmsResponse !== undefined) {
      if (this.cmsResponse.external === 'true') {
        this.type = 'external';
      } else {
        this.type = 'internal';
      }
      this.imageUrl = this.cmsResponse?.media?.url
        ? this.validateDomainNameExistence(this.cmsResponse?.media?.url)
          ? this.cmsResponse.media.url
          : this.baseUrl + this.cmsResponse.media.url
        : '';
      if (this.cmsResponse?.media?.url) {
        this._dataService.addtoDataLayer('view_promotion', this.cmsResponse);
      }
      this.redirectionLink = this.cmsResponse?.urlLink
        ? this.validateDomainNameExistence(this.cmsResponse?.urlLink)
          ? this.cmsResponse?.urlLink
          : this.baseUrl + this.cmsResponse?.urlLink
        : '';
    }
    this.cdr.detectChanges();
  }

  validateDomainNameExistence(url: string) {
    return url.indexOf('https://') === 0 || url.indexOf('www.') === 0;
  }

  gtmSelectPromotion() {
    if (this.cmsResponse?.urlLink) {
      this._dataService.addtoDataLayer('select_promotion', this.cmsResponse);
    }
  }
}
